import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { form, FormProps } from 'shared/utils/form';
import translate, { InjectedTranslateProps } from '../../utils/translate';
import { validate } from '../../utils/validators';
import SubmitButton from '../../components/SubmitButton';
import { routine } from './actions';
import { constraints, FormData } from './constraints';
import { Input } from '../Input';

import './index.scss';

interface Props {}

type Enhanced = Props & InjectedTranslateProps & FormProps<FormData, Props>;

const b = b_.with('password-reset-form');

const enhance = compose<Enhanced, Props>(
  translate,
  form<FormData, Props>(routine, {
    form: 'passwordReset',
    validate: (values) => validate(constraints, values),
  })
);

class PasswordResetForm extends React.Component<Enhanced> {
  render() {
    const { t, formSubmit, submitting, error } = this.props;

    return (
      <form onSubmit={formSubmit} method="POST" data-testid="reset-password-form">
        <Input
          name="email"
          label={t('Email')}
          type="email"
          autoFocus
          classNameInput={b('input-label')}
          tooltipPlacement="bottomLeftSticky"
        />
        <p className="text-secondary">
          {t('Specify registration email and we will send you a recovery link')}
        </p>
        <p className="text-secondary">{t('If you forgot your email please call')}</p>
        <SubmitButton primary className={b('submit-btn')} submitting={submitting} error={error}>
          {t('Reset password')}
        </SubmitButton>
      </form>
    );
  }
}

export default enhance(PasswordResetForm);
